<script lang="ts">
  import { animationsConfig } from "../config/animations";
  import {
    mobileActivityIndex,
    selectedActivityIndex,
  } from "../store/AppState";
  import MobileGifts from "./MobileGifts.svelte";
  import NavigationControls from "./NavigationControls.svelte";

  export let onLoad: () => void;

  const handlePreviousClick = () => {
    $selectedActivityIndex = null;
    $mobileActivityIndex = $mobileActivityIndex - 1;
    if ($mobileActivityIndex < 1) {
      $mobileActivityIndex = animationsConfig.length;
    }
  };

  const handleFollowingClick = () => {
    $selectedActivityIndex = null;
    $mobileActivityIndex = $mobileActivityIndex + 1;
    if ($mobileActivityIndex > animationsConfig.length) {
      $mobileActivityIndex = 1;
    }
  };
</script>

<NavigationControls mobile={true} />
<div class="bottom-controls controls">
  <button on:pointerup={() => handlePreviousClick()}>
    <img src={`${__PUBLIC_PATH__}images/icon-left.svg`} alt="previous" />
  </button>
  {#if !window.isClosed || window.isShowroom}
    <MobileGifts {onLoad} />
  {/if}
  <button>
    <img
      on:pointerup={() => handleFollowingClick()}
      src={`${__PUBLIC_PATH__}images/icon-right.svg`}
      alt="following"
    />
  </button>
</div>

<style>
  .controls {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-height: 15vmin;
    align-items: flex-end;
    z-index: 20;
  }

  .bottom-controls {
    bottom: 0rem;
  }

  .controls img {
    max-width: 80%;
    max-height: 80%;
  }

  .controls button {
    padding: 0;
    border: none;
    width: 15vmin;
    height: 15vmin;
    margin-bottom: 2.15rem;
    z-index: 20;
    background: transparent;
  }
</style>
